import { useState } from "react";
import { copy, types } from "./definitions";

import { SupportApi } from "@twiliointernal/e2-commons-shared-api";
import RequestNotificationView from "./RequestNotificationView";
import { chatService } from "../../../../../../services";

const RequestNotification = ({
  liveChatId,
  onClose,
}: types.RequestNotificationProps) => {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleOnSubmit = async (phone: string) => {
    try {
      setLoading(true);
      const formattedPhone = phone.replace(/ /g, "-");
      const phoneE164 = phone.replace(/ /g, "");

      // Send phone to backend and show the success notification
      const res = await SupportApi.createSupportNotificationRequest({
        channelSid: liveChatId,
        phoneNumber: phoneE164,
      });

      if (!res.success) {
        throw new Error(copy.notificationUnreachable);
      }
      setPhoneNumber(formattedPhone);
    } catch (err: any) {
      let msg = copy.notificationRequestError;
      if (err.message === copy.notificationUnreachable) {
        msg = copy.notificationUnreachable;
      }
      chatService.setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RequestNotificationView
      loading={loading}
      phoneNumber={phoneNumber}
      onSubmit={handleOnSubmit}
      onClose={onClose}
    />
  );
};

export default RequestNotification;
